import React from "react";
import LoadingIcon from "components/LoadingIcon";
import clsx from "clsx";

interface LoadingProps {
  message: string;
  iconClassName?: string;
  containerClassName?: string;
}

export const LoadingView = ({ message, ...props }: LoadingProps) => {
  return (
    <div
      className={clsx(
        "group flex flex-wrap items-center justify-center flex-col font-[500] text-[12px] text-gray-500",
        props.containerClassName
      )}
    >
      <LoadingIcon
        type="primary"
        className={clsx("w-7 h-7 mb-4", props.iconClassName)}
      />
      <p className="text-center">{message}</p>
    </div>
  );
};
